// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fRTf","placeholdersHeader":"styles_placeholdersHeader__Txj7r","editorStyle":"styles_editorStyle__1amPC","placeholdersBox":"styles_placeholdersBox__4fNZJ"};